export const EXTERNAL_URLS = {
  notionProductEngMain:
    'https://www.notion.so/curology/Product-Engineering-b8a3f6c85ca0472e84094be48ff481cd',
  notionGatsbySetup:
    'https://www.notion.so/curology/Gatsby-1e6d1388e1b84e599bc0b46c52c38f3f',
};
